/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import BasicInfo from "layouts/pages/account/settings/components/BasicInfo";
import ChangePassword from "layouts/pages/account/settings/components/ChangePassword";

// Settings page components
import ResumeUpload from "./components/ResumeUpload";
import EducationInfo from "./components/EducationInfo";
import ExperienceInfo from "./components/ExperienceInfo";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CouponCode from "./components/CouponCode";
import { analytics } from "layouts/dashboards/analytics/analytics"; 
import { events } from "layouts/dashboards/analytics/events";
import { AuthContext } from "context";
import { useEffect, useContext } from "react";
function Settings() {

   const { getCurrentUser } = useContext(AuthContext);
    
    useEffect(() => {
      const start_time = Date.now();
      const getUserId = async () => {
        const user = await getCurrentUser();
        return user;
      };
      getUserId().then((user) => {
        analytics.track(events.VIEW_PAGE, { page: "profile-page", userId: user });
      });
      return () => {
        getUserId().then((user) => {
        analytics.track(events.PAGE_LEFT, { page: "profile-page", userId: user, start_time: start_time, end_time: Date.now() });
        });
      }
    }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDTypography variant="h3" fontWeight="medium" mt={1}>
        Account Details
      </MDTypography>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {/* Basic Information */}
                  <BasicInfo />
                </Grid>
                {/* <Grid item xs={12}>
                  
                  <ResumeUpload />
                </Grid>
                <Grid item xs={12}>
                  
                  <ExperienceInfo />
                </Grid>
                <Grid item xs={12}>
                  
                  <EducationInfo />
                </Grid> */}
                <Grid item xs={12}>
                  <CouponCode />
                </Grid>
                <Grid item xs={12}>
                  {/* Change Password */}
                  <ChangePassword />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Settings;
